/**
 * Minimaler Lade-Screen während die Geo-Entscheidung läuft.
 * Bewusst ohne Logo/Branding — sonst flackert beim Übergang
 * zur Info-Seite oder zum KVA jedes Mal das Logo auf.
 */
export function GeoLoadingScreen() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white">
      <div
        className="h-8 w-8 rounded-full border-[3px] border-neutral-200 border-t-neutral-400 animate-spin"
        aria-label="Lädt"
      />
    </div>
  );
}
